<div class="top-banner" [ngStyle]="{'min-height' : height + 'px'}" [ngClass]="backgroundClass">
    <div class="col-12 row m-0 h-100 ">
        <div class="col-12 col-md-6  d-flex align-items-center padding-top-banner">
            <div class="">
                <p class="banner-title-text" [ngStyle]="{'color': backgroundClass == 'banner-blue-bg' ? 'var(--blue700)' : 'var(--blue800)'}">{{title}}</p>
                <p class="banner-subtitle-text" [ngStyle]="{'color': backgroundClass == 'banner-blue-bg' ? 'var(--blue700)' : 'var(--blue700)'}">{{subtitle}}</p>
                <button *ngIf="buttonText != ''" class="btn mt-4" [ngClass]="backgroundClass != 'banner-green-bg' ? 'btn-formed-main-blue' : 'btn-formed-main-blue'" [routerLink]="btnLink" >{{buttonText}}</button>
            </div>
        </div>
        <div [ngStyle]="{'background-image': 'url(' + imgSrc + ')'}" class="relative bg-cover d-none col-md-6 d-md-flex align-items-center justify-content-end borders">
            <div class="overlay"></div>

        </div>
    </div>
</div>
